import { useFormContext } from 'react-hook-form';
import { cn } from '@/utils';
import { BUSINESS_TYPE_OPTIONS, type MotorQuoteFormData } from '../../schema';

export function BusinessTypeStep() {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<MotorQuoteFormData>();

  const businessType = watch('business_type');

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Business Type</h2>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 mb-6">
        Is this a new policy, a renewal, or for a used vehicle changing hands?
      </p>

      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Business Type
        <span className="text-red-500 ml-1">*</span>
      </label>
      <div className="flex flex-col sm:flex-row gap-3">
        {BUSINESS_TYPE_OPTIONS.map((option) => (
          <label
            key={option.value}
            className={cn(
              'flex items-center gap-2 px-4 py-2 rounded-lg border cursor-pointer transition-colors',
              businessType === option.value
                ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20'
                : 'border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700'
            )}
          >
            <input
              type="radio"
              value={option.value}
              checked={businessType === option.value}
              onChange={() => {
                setValue('business_type', option.value, { shouldValidate: true, shouldDirty: true });
                if (option.value !== 'new') {
                  setValue('registration_pending', false, { shouldValidate: true });
                }
              }}
              className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 dark:border-gray-600"
            />
            <span className="text-sm text-gray-700 dark:text-gray-200">{option.label}</span>
          </label>
        ))}
      </div>
      {errors.business_type && (
        <p className="mt-2 text-sm text-red-600 dark:text-red-400">{errors.business_type.message}</p>
      )}
    </div>
  );
}
